import * as BufferLayout from "@solana/buffer-layout";
import * as Layout from "../serialization/layout";
export const SlotInfoLayout = (property) => BufferLayout.struct([Layout.uint64("slot"), BufferLayout.u8("stale")], property);
//# sourceMappingURL=SlotInfo.js.map